//
// Utility fonctions to convert numerical ids to/from task-or-action ids
// (of the form <id>:<type>)
//

export function taskIdFromTaskOrActionId(taskOrActionId): number {
  return Number(taskOrActionId.split(':')[0]);
}

export function messageIdFromTaskOrActionId(taskOrActionId): number {
  return Number(taskOrActionId.split(':')[0]);
}

export function taskOrActionIdFromTaskId(taskId: number): string {
  return `${taskId}:task`;
}

export function taskOrActionIdFromAnswerActionId(actionId: number): string {
  return `${actionId}:answer`;
}

export function taskOrActionIdFromAnnotationActionId(actionId: number): string {
  return `${actionId}:annotation`;
}

export function taskOrActionIdFromHelpRequestActionId(actionId: number): string {
  return `${actionId}:help-request`;
}

export function taskOrActionIdFromHelpAnswerActionId(actionId: number): string {
  return `${actionId}:help-answer`;
}
